<template>
  <bxs-bottom-sheets
    v-model="isShowPopupAddAndTake"
    :title="popopBaseConf.title"
    height="middle"
    use-b-scroll
    @bscroll="bscroll"
  >
    <div v-if="allAddAndTakeData.data && allAddAndTakeData.data.length">
      <component
        :is="poupComponent"
        :age="age"
        :account-data="accountData"
        :all-add-and-take-data="allAddAndTakeData"
        :popop-base-conf="popopBaseConf"
        :form-ele-data="formEleData"
        @openOrClosePopup="openOrClosePopup"
        @deleteAccount="deleteAccount"
      />
    </div>
    <footer slot="footer" class="common_fixed_footer">
      <div class="footer_btn_wrap">
        <template v-if="poupComponent === 'PopupAddAndTakeShow'">
          <span
            v-if="showDeleteAllBtn"
            @click="deleteAllAccount()"
          >删除所有记录</span>
          <span class="active" @click="confirmShowOkBtn()">确定</span>
        </template>
        <template v-if="poupComponent === 'PopupAddAndTakeForm'">
          <span
            v-if="popopBaseConf.formValues && popopBaseConf.formValues.baof"
            @click="deleteAccount()"
          >删除{{ getFormData(formEleData).beginYear }}-{{
            getFormData(formEleData).endYear
          }}年记录</span>
          <span class="active" @click="confirmFormOkBtn()">确定</span>
        </template>
      </div>
    </footer>
  </bxs-bottom-sheets>
</template>

<script>
import { validateAAT, modifyAAT } from '@/api/index'
import PopupAddAndTakeShow from './atrbShow'
import PopupAddAndTakeForm from './atrbForm'
import { BottomSheets, Toast } from 'bxs-ui-vue'

export default {
  name: 'PopupAddTakeReduceBaof',
  components: {
    PopupAddAndTakeShow,
    PopupAddAndTakeForm,
    [Toast.name]: Toast,
    [BottomSheets.name]: BottomSheets
  },
  props: {
    insuredAge: Number,
    uuid: String,
    productKey: [Number, String],
    insuranceKey: [Number, String],
    rawAllAddAndTakeData: Object
    // 结构如下
    // {
    //   accountName: ""
    //   accountPart: "addAndTake"
    //   addAndTakeData: []
    // }
  },
  data () {
    const { rawAllAddAndTakeData } = this
    const copyAllAddAndTakeData = JSON.parse(
      JSON.stringify(rawAllAddAndTakeData)
    )
    if (
      copyAllAddAndTakeData.multiData &&
      Array.isArray(copyAllAddAndTakeData.multiData.twoList)
    ) {
      copyAllAddAndTakeData.data = copyAllAddAndTakeData.multiData.twoList
    }
    return {
      isShowPopupAddAndTake: true,
      age: this.insuredAge,
      poupComponent: '',
      instanceScroll: null,
      allAddAndTakeData: copyAllAddAndTakeData,
      accountData: copyAllAddAndTakeData.accountData,
      formEleData: null,
      popopBaseConf: {
        title: null,
        bonusType: null,
        accountType: null,
        formValues: null
      }
    }
  },
  computed: {
    showDeleteAllBtn () {
      let bool = false
      if (this.accountData.addAndTakeData) {
        bool = this.accountData.addAndTakeData.some(
          ad => ad.adjustData && ad.adjustData.length
        )
      }
      return bool
    },
    moduleTitle () {
      let type = this.accountData.accountPart
      let name = ''
      switch (type) {
        case 'addAndTake':
          name = '追加领取'
          break
        case 'add':
          name = '追加保费'
          break
        case 'take':
          name = '部分领取'
          break
        default:
          break
      }
      return name
    }
  },
  watch: {
    isShowPopupAddAndTake (val) {
      if (!val) {
        if (this.poupComponent === 'PopupAddAndTakeForm') {
          this.poupComponent = 'PopupAddAndTakeShow'
        } else {
          this.$emit('open-or-close-popup')
        }
        this.isShowPopupAddAndTake = true
      }
      this.popopBaseConf.title = this.moduleTitle
    }
  },
  mounted () {
    this.popopBaseConf.title = this.moduleTitle
    this.initAddAndTake()
  },
  methods: {
    bscroll (instance) {
      instance.options.click = true
      this.instanceScroll = instance
    },
    initAddAndTake () {
      // 未追加领取时 twoList = null
      // 需要获取通过验证接口获取数据
      const { uuid, productKey, insuranceKey } = this
      validateAAT({
        uuid,
        productId: productKey,
        insuranceId: insuranceKey,
        addAndTakeData: this.accountData.addAndTakeData
      }).then(({ success, data, info } = {}) => {
        if (!success) {
          this.$toast(info)
          this.$emit('open-or-close-popup')
          return
        }
        this.allAddAndTakeData.data = data
        this.openOrClosePopup('PopupAddAndTakeShow')
      })
    },
    initFormData (accountType) {
      let formData = [
        {
          key: 'beginYear',
          value: null,
          componentName: 'cmCommonSelect',
          labelName: '开始时间',
          opts: null
        },
        {
          key: 'endYear',
          value: null,
          componentName: 'cmCommonSelect',
          labelName: '结束时间',
          opts: null
        },
        {
          key: 'baof',
          value: null,
          componentName: 'cmCommonInput',
          labelName: accountType === 'add' ? '追加金额' : '领取金额',
          placeholder: '请输入金额'
        }
      ]
      if (accountType === 'take') {
        formData.push({
          key: 'purposeType',
          value: null,
          componentName: 'cmCommonSelect',
          labelName: '用途',
          opts: null
        })
        formData.push({
          key: 'purpose',
          value: ''
        })
      }
      return formData
    },
    getFormData (list = []) {
      let data = {}
      list.forEach(e => {
        data[e.key] = e.value
      })
      return data
    },
    getAddAndTake () {},
    deleteAllAccount () {
      let copyAddAndTakeData = this.accountData.addAndTakeData
      if (copyAddAndTakeData && copyAddAndTakeData.length) {
        copyAddAndTakeData.forEach(ad => {
          ad.adjustData = ad.adjustData.splice(0, 0)
        })
        const { uuid, productKey, insuranceKey } = this
        validateAAT({
          uuid,
          productId: productKey,
          insuranceId: insuranceKey,
          addAndTakeData: this.accountData.addAndTakeData
        }).then(({ success, data, info } = {}) => {
          if (!success) return
          this.assignData(data)
        })
      }
    },
    confirmShowOkBtn () {
      const { uuid, productKey, insuranceKey, accountData } = this
      const params = {
        productId: productKey,
        insuranceId: insuranceKey,
        addAndTakeData: accountData.addAndTakeData
      }
      modifyAAT({
        uuid,
        ...params
      }).then(({ success, info } = {}) => {
        if (success) {
          this.$emit('open-or-close-popup')
          this.$emit('update', params)
        } else {
          this.$toast(info)
        }
      })
    },
    deleteAccount (form) {
      const index = this.accountData.addAndTakeData.findIndex(
        item => item.key === this.popopBaseConf.accountType
      )
      const addAndTakeItem = this.accountData.addAndTakeData[index]
      const copyAdjustData = JSON.parse(
        JSON.stringify(addAndTakeItem.adjustData)
      )
      addAndTakeItem.adjustData = this.rebuildAdjustData(
        copyAdjustData,
        form || {
          ...this.getFormData(this.formEleData),
          baof: 0
        }
      )
      const { uuid, productKey, insuranceKey } = this
      validateAAT({
        uuid,
        productId: productKey,
        insuranceId: insuranceKey,
        addAndTakeData: this.accountData.addAndTakeData
      }).then(({ success, data, info } = {}) => {
        if (success) {
          this.openOrClosePopup('PopupAddAndTakeShow', true)
          this.assignData(data)
        } else {
          addAndTakeItem.adjustData = copyAdjustData
          this.accountData.addAndTakeData[index] = addAndTakeItem
          this.$toast(info)
        }
      })
    },
    // 根据修改的数据，重构调整后的数据
    rebuildAdjustData (adjustData, formValues) {
      let allAdjustYears = []
      formValues.purpose = formValues.purposeType || formValues.purpose
      // 遍历调整数据，生成当前所有年度数据
      adjustData.forEach(ad => {
        for (let k = ad[0]; k <= ad[1]; k++) {
          allAdjustYears.push([
            k, // 开始年度
            k, // 结束年度
            ad[2], // 金额
            ad[3] // 用途
          ])
        }
      })

      // 循环调整的起始、结束年度。当前年度数组中已有则替换金额、用途，否则新增
      for (let k = formValues.beginYear; k <= formValues.endYear; k++) {
        let currentYear = allAdjustYears.filter(y => y[0] === k)[0]
        let newYear = [
          k, // 开始年度
          k, // 结束年度
          formValues.baof, // 金额
          formValues.purpose // 用途
        ]
        if (currentYear) {
          currentYear[2] = formValues.baof
          currentYear[3] = formValues.purpose
        } else {
          allAdjustYears.push(newYear)
        }
      }
      allAdjustYears.sort((a, b) => a[0] - b[0])

      // 根据所有年度，重样的生成调整数据
      let newAdjustData = []
      if (allAdjustYears.length > 0) {
        let adjustValue = null
        allAdjustYears.forEach(ad => {
          if (newAdjustData.length < 1) {
            adjustValue = ad[2]
            newAdjustData.push(ad)
          } else {
            if (
              adjustValue === ad[2] &&
              newAdjustData[newAdjustData.length - 1][1] + 1 === ad[0]
            ) {
              newAdjustData[newAdjustData.length - 1][1] = ad[0]
            } else {
              newAdjustData.push(ad)
              adjustValue = ad[2]
            }
          }
        })
      }
      // 金额为0，表示需要删除
      newAdjustData = newAdjustData.filter(ad => ad[2] !== 0)
      return newAdjustData
    },
    // 表单校验
    confirmFormOkBtn () {
      const { uuid, productKey, insuranceKey, popopBaseConf } = this
      const obj = this.getFormData(this.formEleData)
      if (obj.baof !== 0 && !obj.baof) {
        const message = `请输入${
          popopBaseConf.accountType === 'add' ? '追加' : '领取'
        }金额`
        this.$toast(message)
        return
      }
      if (obj.baof < 0 || isNaN(obj.baof)) {
        this.$toast('请输入正整数')
        return
      }
      const index = this.accountData.addAndTakeData.findIndex(
        item => item.key === this.popopBaseConf.accountType
      )
      const addAndTakeItem = this.accountData.addAndTakeData[index]
      const copyAdjustData = JSON.parse(
        JSON.stringify(addAndTakeItem.adjustData)
      )
      addAndTakeItem.adjustData = this.rebuildAdjustData(copyAdjustData, obj)
      this.accountData.addAndTakeData[index] = addAndTakeItem

      validateAAT({
        uuid,
        productId: productKey,
        insuranceId: insuranceKey,
        addAndTakeData: this.accountData.addAndTakeData
      }).then(({ success, data, info } = {}) => {
        if (success) {
          this.openOrClosePopup('PopupAddAndTakeShow', true)
          this.assignData(data)
        } else {
          addAndTakeItem.adjustData = copyAdjustData
          this.accountData.addAndTakeData[index] = addAndTakeItem
          this.$toast(info)
        }
      })
    },
    openOrClosePopup (name, bool = true) {
      if (this.allAddAndTakeData.data && this.allAddAndTakeData.data.length) {
        this.poupComponent = name
        // 打开表单浮层，初始化表单数据
        if (this.poupComponent === 'PopupAddAndTakeForm' && bool) {
          this.formEleData = this.initFormData(this.popopBaseConf.accountType)
        }

        if (this.poupComponent === 'PopupAddAndTakeForm' && !bool) {
          this.poupComponent = 'PopupAddAndTakeShow'
        }
        this.popopBaseConf.title = this.moduleTitle
      } else {
        this.$toast('没有账户数据')
      }
    },
    assignData (data) {
      const ACCOUNT_KEY = 'account_value'
      const { allAddAndTakeData } = this
      const newData = data.find(item => item.key === ACCOUNT_KEY)
      if (!newData) return
      const editIndex = allAddAndTakeData.data.findIndex(
        item => item.key === ACCOUNT_KEY
      )
      this.allAddAndTakeData.data.splice(editIndex, 1, newData)
    }
  }
}
</script>

<style lang="postcss">
.account_add_and_take {
  padding: 0.18rem 0.3rem 0;
  .bx-sheets-content {
    background: #f2f2f2;
  }
  .aaat_table {
    width: 100%;
    border-collapse: collapse;
    caption {
      line-height: normal;
      padding: 0.18rem;
      border: 1px solid #e5e5e5;
      text-align: left;
      h5 {
        width: 65%;
        display: inline-block;
        vertical-align: middle;
        font-size: 0.28rem;
      }
      .aaat_open_btn {
        float: right;
        vertical-align: middle;
        span {
          margin-left: 0.32rem;
          i {
            vertical-align: -1px;
          }
        }
      }
    }
    tbody {
      tr {
        td {
          border-bottom: 1px solid #e5e5e5;
          border-left: 1px solid #e5e5e5;
          padding: 0;
          text-align: left;
          min-width: 0.48rem;
          color: #999;
          vertical-align: middle;
          &:first-child {
            padding: 0.14rem 0.16rem 0.1rem;
            width: 0.8rem;
            text-align: center;
          }
          &:last-child {
            border-right: 1px solid #e5e5e5;
          }
          .aaat_table_tr_td_desc {
            position: relative;
            padding: 0.14rem 0.16rem 0.1rem;
            border-bottom: 1px solid #e5e5e5;
            &:last-child {
              border-bottom: none;
            }
          }
        }
      }
    }
  }
  .common_fixed_footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0.98rem;
    line-height: 0.98rem;
    background: #f8f8f8;
    text-align: center;
    font-size: 0.26rem;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    box-sizing: content-box;
    border-top: 1px solid #e5e5e5;
    .footer_btn_wrap {
      display: flex;
      padding: 0.14rem 0.3rem;
      span {
        flex: 1;
        height: 0.72rem;
        line-height: 0.72rem;
        margin-right: 0.18rem;
        border-radius: 0.12rem;
        background: #fff;
        border: 1px solid #ccc;
        &:last-child {
          margin-right: 0;
        }
        &.active {
          background: var(--primary-color);
          border-color: var(--primary-color);
          color: #fff;
        }
        &.disabled {
          background: #ccc;
          border-color: #ccc;
          color: #fff !important;
        }
      }
    }
  }
}
</style>
